import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Fragment } from 'react';
import { BKTooltipWrapperUIStateProvider, useBKJTooltipWrapperUIStateContext, } from './BKJTooltipWrapper.context.js';
import { BKJComponentWrapper } from './BKJTooltipWrapper.styled.js';
import { BKJTooltip } from './BKJTooltip.js';
const TooltipWrapper = ({ placement, triggerRef, Component, children, }) => {
    const { toggleTooltip, showTooltip } = useBKJTooltipWrapperUIStateContext();
    return (_jsxs(Fragment, { children: [_jsx(BKJComponentWrapper, { ref: triggerRef, onMouseOver: (e) => toggleTooltip(e, true), onMouseLeave: (e) => toggleTooltip(e, false), children: _jsx(Component, {}) }), showTooltip && triggerRef.current && (_jsx(BKJTooltip, { placement: placement, triggerRef: triggerRef, children: children }))] }));
};
export const BKJTooltipWrapper = ({ children, ...props }) => {
    const triggerRef = useRef(null);
    return (_jsx(BKTooltipWrapperUIStateProvider, { children: _jsx(TooltipWrapper, { ...props, triggerRef: triggerRef, children: children }) }));
};
//# sourceMappingURL=BKJTooltipWrapper.js.map